declare var videojs:any;
import { isObject, extend, forEach, orderBy } from 'lodash-es';

if (typeof videojs !== 'undefined') {
  const events = {
    QUALITY_REQUESTED: 'qualityRequested',
    QUALITY_SELECTED: 'qualitySelected',
  };
  const Plugin = videojs.getPlugin('plugin');
  class QualitySwitchPlugin extends Plugin {
    constructor(player, options:any = {}) {
      super(player, options);
      
      this.qualitySelector();
  
    }
    qualitySelector () {
      let MenuButton = videojs.getComponent('MenuButton'),
      QualityOption = this.menuItem(),
      QualitySelector;
      /**
       * A component for changing video resolutions
       *
       * @class QualitySelector
       * @extends videojs.Button
       */
      QualitySelector = videojs.extend(MenuButton, {
  
        /**
          * @inheritdoc
          */
        constructor: function(player, options) {
            MenuButton.call(this, player, options);
  
            // Update interface instantly so the user's change is acknowledged
            player.on(events.QUALITY_REQUESTED, (event, newSource) =>{
              this.setSelectedSource(newSource);
            });
            // Since it's possible for the player to get a source before the selector is
            // created, make sure to update once we get a "ready" signal.
            // player.one('loadedmetadata', () => {
              this.selectedLabel = 'auto';
              this.update();
            // });
  
            this.controlText('Open quality selector menu');
        },
        /**
          * Updates the source that is selected in the menu
          *
          * @param source {object} player source to display as selected
          */
        setSelectedSource: function(source) {
            const height = (source ? source.height : undefined),
              player = this.player();
            
            const qualityLevels = player.qualityLevels();
            forEach(qualityLevels, qualityLevel => {
              if (height === 'auto' || qualityLevel.height === height) {
                qualityLevel.enabled = true;
              } else {
                qualityLevel.enabled = false;
              }
            });             
            if (this.selectedLabel !== source.label) {
              this.selectedLabel = source.label;
              this.update();
            }
        },
        /**
          * @inheritdoc
          */
        createItems: function() {
            var player = this.player(),
                representations = player.tech({ IWillNotUseThisInPlugins: true }).hls && player.tech({ IWillNotUseThisInPlugins: true }).hls.representations();
            
            if (representations && representations.length > 0) {
              return [
                new QualityOption(player, {
                  source: {label:'auto', height:'auto', id:'auto'},
                  selected:'auto' === this.selectedLabel,
                }),            
                ...orderBy(representations, 'height', 'desc').map(r=>(new QualityOption(player, {
                  source:{label:r.height + 'p', ...r},
                  selected:r.id === this.selectedLabel,
                })))  
              ];
            } else {
              return [];
            }     
        },
  
        /**
          * @inheritdoc
          */
        buildWrapperCSSClass: function() {
            return 'vjs-hls-quality-selector ' + MenuButton.prototype.buildWrapperCSSClass.call(this);
        },
        update: function () {
          this.el().querySelector(".vjs-icon-placeholder").innerHTML = this.selectedLabel;
          MenuButton.prototype.update.call(this);
        }
  
      });
      videojs.registerComponent('QualitySelector', QualitySelector);
  
      return QualitySelector;        
    }
  
  
    menuItem () {
      const MenuItem = videojs.getComponent('MenuItem');
  
      /**
       * A MenuItem to represent a video resolution
       *
       * @class QualityOption
       * @extends videojs.MenuItem
       */
      return videojs.extend(MenuItem, {
   
         /**
          * @inheritdoc
          */
         constructor: function(player, options) {
            const source = options.source;
   
            if (!isObject(source)) {
               throw new Error('was not provided a "source" object, but rather: ' + (typeof source));
            }
   
            options = extend({
               selectable: true,
               label: (<any>source).label,
            }, options);
   
            MenuItem.call(this, player, options);
   
            this.source = source;
         },
   
         /**
          * @inheritdoc
          */
         handleClick: function(event) {
            MenuItem.prototype.handleClick.call(this, event);
            this.player().trigger(events.QUALITY_REQUESTED, this.source);
        },
      });    
    }
  }  
  videojs.registerPlugin('qualitySwitch', QualitySwitchPlugin);
  
}

